export const LOADING_STATUS_INITIAL = 'LOADING_STATUS_INITIAL'
export const LOADING_STATUS_DONE = 'LOADING_STATUS_DONE'
export const LOADING_STATUS_LOADING = 'LOADING_STATUS_LOADING'
